import React from "react";
import { useParams, Link } from "react-router-dom";

import styles from "./NewsDetail.module.css";

import newsData from "./NewsData";
import { getImages } from "./getImages";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function NewsDetail() {

  const { slug } = useParams();

  const news = newsData.find(
    item => item.slug === slug
  );

  if (!news) {
    return <h1>404 - News not found</h1>;
  }

  const images = getImages(news.slug);

  // PREV / NEXT

  const sortedData = [...newsData].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const currentIndex = sortedData.findIndex(
    item => item.slug === slug
  );

  const prevPost = sortedData[currentIndex - 1] || null;

  const nextPost = sortedData[currentIndex + 1] || null;

  return (
    <>

      <section className={styles.intro}>

        <h1>{news.title}</h1>

        <p>{news.subtitle}</p>

      </section>

      <div className="wrapper">

        <section className="wrapperContent">

          {/* TEXT */}

          <div className={styles.text}>

            {news.content?.map((paragraph, i) => (

              <p
                key={i}
                className={styles.paragraph}
              >
                {paragraph}
              </p>

            ))}

          </div>

          {/* SLIDER */}

          <Swiper
            className={styles.slider}
            modules={[
              Navigation,
              Pagination,
              Autoplay
            ]}
            spaceBetween={20}
            navigation
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop
            breakpoints={{
              320: {
                slidesPerView: 1
              },

              640: {
                slidesPerView: 2
              },

              1024: {
                slidesPerView: 3
              },
            }}
          >

            {images?.map((src, i) => (

              <SwiperSlide key={i}>

                <img
                  src={src}
                  alt={`${news.title} ${i + 1}`}
                  className={styles.image}
                />

              </SwiperSlide>

            ))}

          </Swiper>

        </section>

        {/* PREV NEXT */}

        <div className={styles.navigationButtons}>

          {prevPost && (

            <Link
              to={`/news/${prevPost.slug}`}
              className={styles.prevButton}
            >
              ← {prevPost.title}
            </Link>

          )}

          {nextPost && (

            <Link
              to={`/news/${nextPost.slug}`}
              className={styles.nextButton}
            >
              {nextPost.title} →
            </Link>

          )}

        </div>

      </div>

    </>
  );
}